import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Admin", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("LTE")
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "login-box-msg" }, "Sign in to start your session", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Remember Me ")
const _hoisted_11 = { class: "col-5" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Sign In ")
const _hoisted_13 = { class: "social-auth-links text-center mt-2 mb-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Sign in using Facebook ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Sign in using Google ")
const _hoisted_16 = { class: "mb-1" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" I forgot my password ")
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Register a new membership ")

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_checkbox = _resolveComponent("app-checkbox")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "h1"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.loginByAuth && _ctx.loginByAuth(...args)), ["prevent"]))
        }, [
          _createVNode(_component_app_input, {
            icon: "envelope",
            class: "mb-3",
            type: "email",
            placeholder: "Email",
            autocomplete: "off",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Password",
            autocomplete: "off",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.password) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_app_checkbox, {
                modelValue: _ctx.rememberMe,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.rememberMe) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true",
                loading: _ctx.isAuthLoading,
                disabled: _ctx.isFacebookLoading || _ctx.isGoogleLoading
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_app_button, {
            class: "btn-primary",
            icon: "facebook",
            block: "true",
            onClick: _ctx.loginByFacebook,
            loading: _ctx.isFacebookLoading,
            disabled: _ctx.isAuthLoading || _ctx.isGoogleLoading
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]),
          _createVNode(_component_app_button, {
            class: "btn-danger",
            icon: "google-plus",
            block: "true",
            onClick: _ctx.loginByGoogle,
            loading: _ctx.isGoogleLoading,
            disabled: _ctx.isAuthLoading || _ctx.isFacebookLoading
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _createElementVNode("p", _hoisted_16, [
          _createVNode(_component_router_link, { to: "/forgot-password" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/register",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}